import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";
import type { IWarehouseResponse } from "@api/stores/warehouses/types";

import type { IPathBaseParam } from "./path";
import type { IWarehouseGetAllParams } from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IWarehouseResponse>>,
  IPathBaseParam,
  IPaginationParams & IWarehouseGetAllParams
>("users.warehouses");

export const warehouses = {
  ...getAllApis,
};
